import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FiSearch } from "react-icons/fi";
import ProductCard from "./ProductCard";
import { findSubCategory, normalize } from "./catalogueData";
import "./Catalogue.css";

const ProductListWithFilters = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { idcode } = useParams();
  const [searchTerm, setSearchTerm] = useState("");

  const found = useMemo(() => findSubCategory(idcode), [idcode]);

  const items = useMemo(() => {
    if (!found) return [];
    const query = normalize(searchTerm);
    return (found.sub.produits || []).filter((p) =>
      normalize(p.titre).includes(query)
    );
  }, [found, searchTerm]);

  if (!found) {
    return (
      <div className="cat">
        <div className="cat-notfound">
          <h1>Catégorie introuvable</h1>
          <Link to="/catalogue" className="cat-btn">
            Retour au catalogue
          </Link>
        </div>
      </div>
    );
  }

  const { category, sub } = found;

  return (
    <div className="cat">
      <header className="cat-hero cat-hero--compact">
        <nav className="cat-breadcrumb" aria-label="Fil d'Ariane">
          <Link to="/catalogue">Catalogue</Link>
          <span>/</span>
          <span>{category.nom}</span>
          <span>/</span>
          <strong>{sub.nom.trim()}</strong>
        </nav>
        <motion.h1
          className="cat-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {sub.nom.trim()}
        </motion.h1>
        {sub.description && (
          <motion.p
            className="cat-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            {sub.description}
          </motion.p>
        )}
        <label className="cat-search">
          <FiSearch aria-hidden="true" />
          <input
            type="search"
            placeholder="Rechercher un produit..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </label>
      </header>

      <div className="cat-chips">
        {category.souscategories.map((s) => (
          <Link
            key={s.idcode}
            to={`/catalogue/${s.idcode}`}
            className={`cat-chip${s.idcode === sub.idcode ? " is-active" : ""}`}
          >
            {s.nom.trim()}
          </Link>
        ))}
      </div>

      <main className="cat-main">
        {items.length > 0 ? (
          <div className="cat-products">
            {items.map((product, i) => (
              <ProductCard key={product.id} product={product} index={i} />
            ))}
          </div>
        ) : (
          <p className="cat-empty">
            {searchTerm
              ? `Aucun produit ne correspond à « ${searchTerm} ».`
              : "Aucun produit dans cette catégorie pour le moment."}
          </p>
        )}
        <Link to="/catalogue" className="cat-back">
          ← Toutes les catégories
        </Link>
      </main>
    </div>
  );
};

export default ProductListWithFilters;
